import { useState, type FC, type ReactNode } from 'react'

import { Box, Button, Icon, Table, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { ExplotableItem } from 'modules/core/components/GroupingExplotable'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

interface Props {
  name: string
  id?: string
  count: number
  children: ReactNode
  onBulkEdit: () => void
  canAssingJobs: boolean
  teamId: string
}

const ExpandableGroup: FC<Props> = ({
  name,
  id,
  count,
  children,
  onBulkEdit,
  canAssingJobs,
  teamId,
}) => {
  const [open, setOpen] = useState(true)
  const { navigation } = useNavigation()

  return (
    <ExplotableItem
      key={id}
      bottomRadius={false}
      dropDownAnimated={false}
      expandIcon="caret"
      headerBorders={false}
      headerRounded={false}
      opened={open}
      renderHeader={() => (
        <Text.Normal size="200" weight="medium" color="grey800">
          {name} ({count})
        </Text.Normal>
      )}
      scrollLimited={false}
      size="small"
      toggle={() => setOpen(!open)}
      type="primary"
    >
      {count > 0 && (
        <Table noRadius hideBorder>
          <Table.Body>
            {name === i18n.t('teams.unassigned_role') && canAssingJobs && (
              <Table.Row background="viridian100">
                <Table.Cell colSpan={7}>
                  <Box justifyContent="spaceBetween" flexDirection="row" alignItems="center">
                    <Box flexDirection="row" gap="s12" alignItems="center">
                      <Icon.Small icon="info" color="viridian1200" encircled={'viridian1200'} />
                      <Text.Normal color="grey1000" size="200" weight="normal">
                        {i18n.t('teams.unassigned_member')}
                      </Text.Normal>
                    </Box>

                    <Box flexDirection="row" justifyContent="spaceAround" gap="s8">
                      <Button onClick={onBulkEdit} type="positive">
                        {i18n.t('job_catalog.assign_role')}
                      </Button>
                      <Button.Router
                        to={`${navigation.employees.teams.id.addJobCatalogRole.fullPath({
                          id: teamId,
                        })}?fallbackRoute=${navigation.employees.teams.id.jobCatalogRoleCreated.fullPath(
                          {
                            id: teamId,
                          }
                        )}`}
                        type="positive"
                        onClick={() => track(trackingEvents.teams.assignJobThroughTeamList)}
                      >
                        {i18n.t('job_catalog.create_role')}
                      </Button.Router>
                    </Box>
                  </Box>
                </Table.Cell>
              </Table.Row>
            )}
            {children}
          </Table.Body>
        </Table>
      )}
    </ExplotableItem>
  )
}

export default observer(ExpandableGroup)
